import { Div } from "../../Div";

export class SimpleListItem extends Div {
    protected createSelf() {
        super.createSelf();
        this.addClass("i");
    }
}
